import { useChatContext } from './ChatContext';
import { WIDE_SHELL_MIN_WIDTH } from './useShellWidth';
import { getLabel } from '@/i18n/maps';
import { ART } from '@/art';

/**
 * The greeting at the top of the conversation: "Bonjour ! 👋" and the advisor on a
 * botanical background.
 */
export function Greeting(): JSX.Element {
  const { shellWidth, locale } = useChatContext();
  const narrow = shellWidth != null && shellWidth < WIDE_SHELL_MIN_WIDTH;

  // "**Flo**" in the label is bold; its line break shows (white-space: pre-line)
  const body = getLabel('greeting_body', locale)
    .split('**')
    .map((part, i) => (i % 2 ? <b key={i}>{part}</b> : part));

  return (
    <section className={`cal-greet${narrow ? ' is-narrow' : ''}`}>
      <img
        className="cal-greet-bg"
        src={ART.greetingBackground(1600)}
        srcSet={`${ART.greetingBackground(800)} 800w, ${ART.greetingBackground(1600)} 1600w`}
        sizes="(min-width: 840px) 800px, 100vw"
        alt=""
      />
      <div className="cal-greet-text">
        <h2>
          {getLabel('greeting_title', locale)} <span aria-hidden="true">👋</span>
        </h2>
        <p>{body}</p>
      </div>
      <img className="cal-greet-advisor" src={ART.greetingAdvisor} alt="" />
    </section>
  );
}
